module.exports = __webpack_public_path__ + "assets/img/travel-day5.79a3762b.png";